import React, { Suspense, useMemo } from "react";
import { useAppConfig } from "@/appConfig";
import { useSearchParams } from "react-router-dom";

export default function AgentWantAdEditor(props) {
  const { flags } = useAppConfig();
  const [searchParams] = useSearchParams();
  const forceClassic = searchParams.get("classic") === "1";

  const LazyEditor = useMemo(() => {
    if (flags.aiCreateFlow && !forceClassic) {
      return React.lazy(() => import("./AiWantAdCoWork"));
    }
    return React.lazy(() =>
      flags.mlsAgentEditor
        ? import("./MLSAgentCreateOrEditWantAd")
        : import("./AgentCreateOrEditWantAd"),
    );
  }, [flags.mlsAgentEditor, flags.aiCreateFlow, forceClassic]);

  return (
    <Suspense fallback={null}>
      <LazyEditor {...props} />
    </Suspense>
  );
}
